import React, { useState, useEffect, useContext } from "react";
import Axios from "axios";
import clsx from "clsx";
import TimeEntryTable from "./TimeEntryTable";
import { DataContext, SettingContext } from "../DataContext";
import QuickEntryFilter from "./QuickEntryFilter";
import { getError } from "../utils/functions";
import CustomTablePagination from "./CustomTablePagination";
import QuickEntrySummary from "./QuickEntrySummary";

const DisplayTimeEntry = ({
  className,
  selectedCaseSid,
  selectedStaffSid,
  tabIndex,
  hideCaseCol,
  hideStaffCol,
  hideClockedTimeCol,
  hideStaffFilter,
}) => {
  const allOpt = { id: "all", value: "All" };
  const { alertError } = useContext(DataContext);
  const { refetch } = useContext(SettingContext);

  const [loading, setLoading] = useState(false);
  const [timeEntryData, setTimeEntryData] = useState(null);

  const [staffFilter, setStaffFilter] = useState(allOpt);
  const [dateRange, setDateRange] = useState([null, null]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const fetchQuickEntryList = (
    caseSid = selectedCaseSid,
    personSid = staffFilter?.id,
    fromDate = dateRange[0],
    toDate = dateRange[1],
    page = currentPage,
    size = pageSize
  ) => {
    let link = `/view-entries?type=time&showArchivedData=true&caseSid=${
      caseSid || "all"
    }&personSid=${personSid || "all"}&page=${page || 1}&size=${size || 50}`;
    if (fromDate) {
      link += `&fromDate=${fromDate}`;
    }
    if (toDate) {
      link += `&toDate=${toDate}`;
    }
    setLoading(true);
    Axios.get(link)
      .then((res) => {
        setTimeEntryData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        alertError(getError(err));
        setTimeEntryData(null);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!tabIndex || tabIndex === 1) {
      fetchQuickEntryList(
        selectedCaseSid,
        selectedStaffSid || staffFilter?.id,
        dateRange[0],
        dateRange[1],
        currentPage,
        pageSize
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tabIndex,
    selectedCaseSid,
    selectedStaffSid,
    staffFilter,
    dateRange,
    currentPage,
    pageSize,
    refetch,
  ]);

  const handleChangePage = (e, newPage) => setCurrentPage(newPage + 1);

  const handleChangeSize = (e) => setPageSize(parseInt(e.target.value));

  const isFiltering =
    dateRange[0] || dateRange[1] || (staffFilter && staffFilter.id !== "all");

  return (
    <div className={clsx("DisplayTimeEntry", className)}>
      <QuickEntryFilter
        staffFilter={staffFilter}
        setStaffFilter={setStaffFilter}
        dateRange={dateRange}
        setDateRange={setDateRange}
        hideStaffFilter={hideStaffFilter}
        isFiltering={isFiltering}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
        personSid={selectedStaffSid}
        caseSid={selectedCaseSid}
        type="time"
        isLoading={loading}
      />
      {!isFiltering && (
        <CustomTablePagination
          loading={loading}
          totalElements={timeEntryData?.totalElements}
          size={pageSize}
          page={currentPage}
          handleChangePage={handleChangePage}
          handleChangeSize={handleChangeSize}
        />
      )}
      <TimeEntryTable
        isLoading={loading}
        data={timeEntryData?.content}
        hideCaseCol={hideCaseCol}
        hideStaffCol={hideStaffCol}
        hideClockedTimeCol={hideClockedTimeCol}
      />
      <QuickEntrySummary
        isLoading={loading}
        data={timeEntryData?.content}
        type="time"
      />
    </div>
  );
};

export default DisplayTimeEntry;
